import api from './api';

/**
 * Notary Offices Service
 * Handles all notary office management API calls
 */
const notaryOfficesService = {
    /**
     * Get all notary offices with pagination and filters
     * @param {Object} params - Query parameters
     * @returns {Promise<Object>}
     */
    getAll: async (params = {}) => {
        const queryString = new URLSearchParams(params).toString();
        return api.get(`/admin/notary-offices${queryString ? `?${queryString}` : ''}`);
    },

    /**
     * Get notary office by ID
     * @param {string} id - Office ID
     * @returns {Promise<Object>}
     */
    getById: async (id) => {
        return api.get(`/admin/notary-offices/${id}`);
    },

    /**
     * Create new notary office with file upload
     * @param {Object} data - Office data
     * @param {File} imageFile - Image file (optional)
     * @returns {Promise<Object>}
     */
    create: async (data, imageFile = null) => {
        const formData = new FormData();
        
        // Add all data fields
        Object.keys(data).forEach(key => {
            if (key !== 'image' && key !== 'imagePreview' && data[key] !== null && data[key] !== undefined) {
                if (Array.isArray(data[key])) {
                    formData.append(key, JSON.stringify(data[key]));
                } else {
                    formData.append(key, data[key]);
                }
            }
        });

        // Add image file if provided
        if (imageFile) {
            formData.append('image', imageFile);
        }

        return api.postMultipart('/admin/notary-offices', formData);
    },

    /**
     * Update notary office with file upload
     * @param {string} id - Office ID
     * @param {Object} data - Updated office data
     * @param {File} imageFile - New image file (optional)
     * @returns {Promise<Object>}
     */
    update: async (id, data, imageFile = null) => {
        const formData = new FormData();
        
        // Add all data fields
        Object.keys(data).forEach(key => {
            if (key !== 'image' && key !== 'imagePreview' && data[key] !== null && data[key] !== undefined) {
                if (Array.isArray(data[key])) {
                    formData.append(key, JSON.stringify(data[key]));
                } else {
                    formData.append(key, data[key]);
                }
            }
        });

        // Add image file if provided
        if (imageFile) {
            formData.append('image', imageFile);
        }

        return api.putMultipart(`/admin/notary-offices/${id}`, formData);
    },

    /**
     * Delete notary office
     * @param {string} id - Office ID
     * @returns {Promise<Object>}
     */
    delete: async (id) => {
        return api.delete(`/admin/notary-offices/${id}`);
    }
};

export default notaryOfficesService;
